/* eslint-disable */
import React, { useLayoutEffect } from "react";
import { HospitalIndemnityInsuranceBrochure, GlobeLifeLogo } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBHospitalIndemintyImage from "../../../../../assets/VEBPlanImages/VEBHospitalIndemnityImage.avif";
import "./hospitalIndemnity.scss";

const HospitalIndemnity: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="hospital-indemnity-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Hospital Indemnity Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={GlobeLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							A sevore injury or illence requiring hospitalization can strike you or a loved one at any
							time. Even if you are covered by major medical insurance, a hospital stay of any duration
							can lead to significant out-of-pocket expenses. Having additional coverage on your side will
							help to limit those costs.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A Globe Life Hospital Indemnity policy gives you an extra layer of financial
							security during these tough times—providing benefits that you can use to help keep the bills
							paid and protect your savings. That way, your focus can be on getting better.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBHospitalIndemintyImage} alt="VEBHospitalIndemintyImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={HospitalIndemnityInsuranceBrochure} />
			</div>
		</div>
	);
};

export default HospitalIndemnity;
